<template>
  <section>
    <BigImageAndTitleBlocks :items="data.category_urls"/>
  </section>
</template>

<style scoped>

</style>

<script>
import BigImageAndTitleBlocks from "@/components/organisms/BigImageAndTitleBlocks.vue";

export default {
  props: {
    data: Object
  },
  components: {BigImageAndTitleBlocks}

}
</script>
